$(function () {
  // URLのパラメータを取得
  const urlParams = new URLSearchParams(window.location.search);

  // 「filter.p.m.custom」から始まるキーが存在するかを判定
  let hasFilterParam = false;
  for (let [key, value] of urlParams) {
    if (key.startsWith("filter.p.m.custom")) {
      hasFilterParam = true;
      // 見つかったらループを抜ける
      break;
    }
  }

  // 条件判定
  if (hasFilterParam) {
    // 「filter.p.m.custom」から始まるパラメータが存在する場合の処理
    $("#collectionTitle").text("絞り込み結果");
  }
});
